<ng-container *ngIf="activevalue===1">
  <i class="fas fa-circle fa-sm text-success"></i>
</ng-container>
<ng-container *ngIf="activevalue===0">
  <i class="fas fa-circle fa-sm text-danger"></i>
</ng-container>
